export const tableOption = {
  dialogDrag: true,
   border: true,
  indexLabel: "序号",
  height:"calc(100vh - 460px)",
  stripe: false,
  menuAlign: "center",
  menuType: "text",
  searchShow: true,
  excelBtn: false,
  printBtn: false,
  defaultSort:{
    prop:'bindingDate',
    order:'descending'
  },
  viewBtn: false,
  searchBtn:false,
  emptyBtn:false,
  searchMenuSpan: 24,
  menuWidth:90,
  align:"left",
  searchLabelWidth:80,
  column: [
    {
      label: "C卡卡号",
      prop: "cardNo",
      sortable: true,
      search:true,
      minWidth:130,
      overHidden:true,
      searchOrder:1,
    },
    {
      label: "B卡卡号",
      prop: "parentCardNo",
      search:true,
      minWidth:160,
      overHidden:true,
      searchOrder:5,
    },  {
      label: "车队长",
      prop: "captainName",
      search:true,
      minWidth:100,
      overHidden:true,
      searchOrder:4,
    },

    {
      label: "激活时间",
      prop: "bindingDate",
      sortable: true,
      type:"datetime",
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      minWidth:140,
      overHidden:true,
     
    },
   
    {
      label: "手机号",
      prop: "mobile",
      searchLabelWidth:100,
      search:true,
      minWidth:110,
      overHidden:true,
      searchOrder:6,
    },
    {
      label: "状态",
      prop: "status",
      search:true,
      sortable: true,
      type:"select",
      props: {
        label: "itemName",
        value: "itemValue",
      },
      dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=card_status',
      minWidth:80,
      overHidden:true,
      searchOrder:3,
    },
   
    {
      label: "激活时间",
      prop: "searchDate",
      sortable: true,
      type:"date",
      searchRange:true,
      search: true,
      hide:true,
      showColumn:false,
      valueFormat: 'yyyy-MM-dd',
      searchOrder:2,
    },
 
    {
      label: "运单总数",
      prop: "waybillCount",
      sortable: true,
      minWidth:100,
      overHidden:true,
    },
    {
      label: "已交运单数",
      prop: "giveCardCount",
      minWidth:100,
      overHidden:true,
    },
    {
      label: "待结算金额",
      prop: "unsettledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已结算金额",
      prop: "settledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已付款金额",
      prop: "paidAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },

  ],
};
